import { httpClient } from '@/lib/api';

import type { AuthUser, LoginPayload, LoginResponse } from '../types';

/**
 * Appels réseau du domaine authentification.
 *
 * ⚠️ Ces routes ne sont **pas encore implémentées côté backend** : le module
 * `Backend/src/modules/auth/` est vide. Les signatures ci-dessous fixent le
 * contrat à respecter lors de son écriture ; le front est prêt à les consommer
 * sans modification.
 */
export const authApi = {
  /** `POST /auth/login` — dépose le cookie de refresh et renvoie le token d'accès. */
  login: (payload: LoginPayload): Promise<LoginResponse> =>
    httpClient.post<LoginResponse>('/auth/login', payload, { skipAuth: true }),

  /**
   * `POST /auth/refresh` — échange le cookie de refresh contre un nouveau
   * token d'accès.
   *
   * ⚠️ À n'appeler que par `refreshSession()` (`../session-refresh.ts`), qui
   * porte le verrou à un seul appel en vol. Deux échanges concurrents portent
   * le même cookie : le second se présente avec un jeton déjà consommé, et le
   * serveur révoque alors **toutes** les sessions du compte.
   */
  refresh: (): Promise<LoginResponse> =>
    httpClient.post<LoginResponse>('/auth/refresh', undefined, { skipAuth: true }),

  /** `POST /auth/logout` — révoque le refresh token et efface le cookie. */
  logout: (): Promise<void> => httpClient.post<void>('/auth/logout'),

  /** `GET /auth/me` — profil de l'utilisateur connecté. */
  me: (): Promise<AuthUser> => httpClient.get<AuthUser>('/auth/me'),
};
